import { Link, type LinkProps } from '@/components/ui'
import { cn } from '@/lib/utils'

// The one in-content link style: Collectia Blue text + underline, turquoise
// focus ring. Blue (not turquoise) text because turquoise on white fails AA for
// small text (DESIGN_GUIDELINES §7). Exported so a native <a> that can't use the
// Inertia router (e.g. a file download) can match the style — see exports page.
export const textLinkClasses = cn(
  'rounded-sm font-medium text-text-strong underline underline-offset-2 hover:text-brand-blue',
  'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-turquoise',
)

/**
 * Inertia-routed in-content link. Use for every textual link (table cells,
 * "View all", banner actions) so links read consistently. For links that must
 * be a plain anchor (downloads, external), apply `textLinkClasses` to an `<a>`.
 */
export function TextLink({ className, ...props }: LinkProps) {
  return <Link {...props} className={cn(textLinkClasses, className)} />
}
